import { allPass, complement, eqProps } from 'ramda';
import compose from 'recompose/compose';
import { uniqueId } from 'lodash';
import { connect } from 'react-redux';
import withHandlers from 'recompose/withHandlers';
import withPropsOnChange from 'recompose/withPropsOnChange';
import renderNothing from 'recompose/renderNothing';
import { getTips } from '../tipping/selectors';
import { getCustomerId } from '../customer/selectors';
import { getIsOrderEmpty, getOrderDiscounts, getOrderItems, getSelectedMembership } from '../order/selectors';
import { getPromoCode } from '../promo/selectors';
import { resetValidation, validateSaleSuccess, validateSale, validateSaleError } from '../validated/actions';
import { getPayments } from '../payment/reducer/payments/selectors';
import { getOrderForValidation } from '../selectors';
import withValidateSaleAction from './withValidateSaleAction';

let validationInProgress = null;

const withValidateSale = compose(
  withValidateSaleAction,
  connect(
    state => ({
      orderDiscounts: getOrderDiscounts(state),
      promoCode: getPromoCode(state),
      customerId: getCustomerId(state),
      payments: getPayments(state),
      order: getOrderForValidation(state),
      orderItems: getOrderItems(state),
      orderMembership: getSelectedMembership(state),
      isOrderEmpty: getIsOrderEmpty(state),
      tips: getTips(state),
    }),
    { validateSale, validateSaleSuccess, resetValidation, validateSaleError }
  ),
  withHandlers({
    validateSale: props => () => {
      if (props.isOrderEmpty) {
        validationInProgress = null;
        return props.resetValidation();
      }
      const id = uniqueId();
      validationInProgress = id;
      const isCurrentValidation = () => validationInProgress === id;
      props.validateSale();
      return props.validateSaleAction(props.order).then((response) => {
        if (isCurrentValidation()) return props.validateSaleSuccess(response);
        return null;
      }).catch(() => {
        if (isCurrentValidation()) return props.validateSaleError();
        return null;
      });
    },
  }),
  withPropsOnChange(
    complement(allPass([
      eqProps('orderItems'),
      eqProps('orderDiscounts'),
      eqProps('orderMembership'),
      eqProps('promoCode'),
      eqProps('customerId'),
      eqProps('tips'),
      // Payment changes are handled when adding a payment
      // this handles removing of the payments
      (props, nextProps) => nextProps.payments.length >= props.payments.length,
    ])),
    (props) => {
      props.validateSale();
    }
  ),
);
export default withValidateSale;
export const ValidateSale = withValidateSale(renderNothing());
